import React, { useEffect, useState } from "react";
import { Trash2, Plus, Hammer, SaveAll } from "lucide-react";
import uploadmutiplefile from "../../common/Uploadmultplefile";
import toast from "react-hot-toast";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const Servicelogbillestimation = ({
  workOrderDetail,
  serviceBillData,
  setServiceBillData,
  serviceBillDetails,
  setBillDetailsDetails,
  setActiveTab,
  creationType,
  getVehicleTaskDetails,
  handleImageOpen,
  setCreationType,
  getServiceBillDetails,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [errors, setErrors] = useState({});

  const addRow = () => {
    setServiceBillData([
      ...serviceBillData,
      {
        estimationAmount: null,
        description: null,
        invoiceBillAttachment: null,
        labourCost: null,
        taxPercentage: null,
        cgstPercentage: null,
        cgstAmount: null,
        sgstPercentage: null,
        sgstAmount: [],
        taxAmount: null,
        discountPercentage: null,
        discountAmount: null,
      },
    ]);
  };

  const parseImages = (value) => {
    try {
      if (!value) return [];

      // If already array → return as is
      if (Array.isArray(value)) return value;

      // If it's a string → parse it
      const parsed = typeof value === "string" ? JSON.parse(value) : value;

      // If parsed is array → return
      if (Array.isArray(parsed)) return parsed;

      // If it's a single object → wrap in array
      if (typeof parsed === "object") return [parsed];

      return [];
    } catch (e) {
      return [];
    }
  };

  function ccyFormat(num) {
    return `${Number(num || 0).toFixed(2)}`;
  }

  const removeRow = (index) => {
    const updated = serviceBillData.filter((_, i) => i !== index);
    setServiceBillData(updated);
  };

  const validateStep1 = () => {
    let errors = {};

    if (!serviceBillData[0].description)
      errors.description = "Description is required";
    if (!serviceBillData[0].laborCount)
      errors.laborCount = "Labour Count is required";
    // if (!serviceBillData[0].attachements) errors.attachements = "Attachments is required";
    if (!serviceBillData[0].serviceAmount)
      errors.serviceAmount = "Service Amount is required";
    // if (!serviceBillData[0].laborCost) errors.laborCost = "Labor Cost is required";

    return errors;
  };

  const saveRow = async () => {
    const validationErrors = validateStep1();
    console.log("validationErrors", validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill all required fields");
      return;
    }

    setErrors({});

    let payload;

    if (creationType?.type === "new") {
      payload = {
        laborCount: serviceBillData[0].laborCount,
        serviceAmount: Number(serviceBillData[0].serviceAmount),
        description: serviceBillData[0].description,
        sgstAmount: serviceBillData[0].sgstAmount || null,
        sgstPercentage: serviceBillData[0]?.sgstPercentage || null,
        cgstAmount: serviceBillData[0].cgstAmount || null,
        cgstPercentage: serviceBillData[0]?.cgstPercentage || null,
        totalTaxPercentage: serviceBillData[0]?.totalTaxPercentage || null,
        totalTax: Number(serviceBillData[0]?.totalTaxAmount || 0),
        totalTaxAmount: Number(serviceBillData[0]?.totalTaxAmount || 0),
        totalCost: Number(serviceBillData[0]?.totalCost || 0),
        // laborCost: Number(serviceBillData[0]?.laborCost || 0),
        attachments: JSON.stringify(serviceBillData[0].attachements),
        logId: workOrderDetail?.id,
      };
    } else {
      payload = {
        laborCount: serviceBillData[0].laborCount,
        serviceAmount: Number(serviceBillData[0].serviceAmount),
        description: serviceBillData[0].description,
        sgstAmount: serviceBillData[0].sgstAmount || null,
        sgstPercentage: serviceBillData[0]?.sgstPercentage || null,
        cgstAmount: serviceBillData[0].cgstAmount || null,
        cgstPercentage: serviceBillData[0]?.cgstPercentage || null,
        totalTaxPercentage: serviceBillData[0]?.totalTaxPercentage || null,
        totalTax: Number(serviceBillData[0]?.totalTaxAmount || 0),
        totalTaxAmount: Number(serviceBillData[0]?.totalTaxAmount || 0),
        totalCost: Number(serviceBillData[0]?.totalCost || 0),
        // laborCost: Number(serviceBillData[0]?.laborCost || 0),
        attachments: JSON.stringify(serviceBillData[0].attachements),
        logId: workOrderDetail?.id,
        id: creationType?.id,
      };
    }

    try {
      const res = await fetch(`${apiUrl}/api/laborservices`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data?.statusCode === "0100") {
        toast.success("Vehicle Service Task Added Successfully 🎉");

        setServiceBillData([
          {
            estimationAmount: null,
            description: null,
            invoiceBillAttachment: null,
            labourCost: null,
            taxPercentage: null,
            cgstPercentage: null,
            cgstAmount: null,
            sgstPercentage: null,
            sgstAmount: [],
            taxAmount: null,
            discountPercentage: null,
            discountAmount: null,
          },
        ]);
        setCreationType({
          type: "new",
          id: null,
        });
        // setActiveTab("summary");
        await getServiceBillDetails(workOrderDetail?.id);
      }
    } catch (err) {
      toast.error("Something went wrong");
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...serviceBillData];
    updated[index][field] = value;
    setServiceBillData(updated);
  };

  const handleFileChange = async (index, files) => {
    const res = await uploadmutiplefile(files, "vehicles", "vehicle");

    const uploaded = res?.uploaded || [];

    setServiceBillData((prev) => {
      const updated = [...prev];

      updated[index].attachements = [
        ...(updated[index].attachements || []),
        ...uploaded,
      ];

      return updated;
    });
  };

  const getFileType = (url = "") => {
    const ext = url.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (["mp4", "webm", "ogg"].includes(ext)) return "video";
    if (["pdf"].includes(ext)) return "pdf";
    if (["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(ext))
      return "doc";

    return "other";
  };

//   useEffect(() => {
//     setServiceBillData((prev) => {
//       const updated = [...prev];
//       const cgst = Number(serviceBillData[0]?.cgstPercentage || 0);
//       const sgst = Number(serviceBillData[0]?.sgstPercentage || 0);
//       const explicitTotalTax = Number(
//         serviceBillData[0]?.totalTaxPercentage ||
//           serviceBillData[0]?.totalTax ||
//           0,
//       );
//       const computedTotalTaxPercentage = cgst + sgst;
//       const totalTaxPercentage = computedTotalTaxPercentage || explicitTotalTax;
//       updated[0].totalTaxPercentage = totalTaxPercentage;

//       const base =
//         Number(serviceBillData[0]?.serviceAmount || 0) +
//         Number(serviceBillData[0]?.laborCost || 0);
//       const totalTaxRate = totalTaxPercentage;
//       const totalTaxAmount = isFinite(base) ? (base * totalTaxRate) / 100 : 0;
//       updated[0].totalTaxAmount = Number(totalTaxAmount.toFixed(2));
//       updated[0].totalCost = Number((base + totalTaxAmount).toFixed(2));
//       return updated;
//     });
//   }, [
//     serviceBillData[0]?.sgstPercentage,
//     serviceBillData[0]?.cgstPercentage,
//     serviceBillData[0]?.serviceAmount,
//     serviceBillData[0]?.laborCost,
//     serviceBillData[0]?.totalTaxPercentage,
//     serviceBillData[0]?.totalTax,
//   ]);

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold text-slate-800 flex items-center gap-2">
          <Hammer className="text-blue-600 w-5 h-5" />
          Service Bill Estimation
        </h2>

        <button
          type="button"
          onClick={addRow}
          disabled={serviceBillData.length >= 1}
          className="text-sm bg-blue-600 text-white px-3 py-1.5 rounded-lg hover:bg-blue-700 transition flex items-center gap-1"
        >
          <Plus size={16} />
          Add Bill
        </button>
      </div>

      <div className="space-y-3">
        {serviceBillData.map((task, index) => (
          <div
            key={index}
            className="grid grid-cols-12 gap-3 items-center bg-gray-200 p-3 rounded-lg border border-gray-100"
          >
            <div className="col-span-2">
              <input
                type="number"
                placeholder="Estimation Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.estimationAmount}
                onChange={(e) =>
                  handleChange(index, "estimationAmount", e.target.value)
                }
              />
            </div>            

            <div className="col-span-2">
              <input
                type="text"
                placeholder="description"
                className="w-full border rounded-md p-2 text-sm"
                value={task.description}
                onChange={(e) =>
                  handleChange(index, "description", e.target.value)
                }
              />
            </div>

            <div className="col-span-2">
              <input
                type="number"
                placeholder="labour Cost"
                className="w-full border rounded-md p-2 text-sm"
                value={task.labourCost}
                onChange={(e) =>
                  handleChange(index, "labourCost", e.target.value)
                }
              />
            </div>   

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Tax Percentage"
                className="w-full border rounded-md p-2 text-sm"
                value={task.taxPercentage}
                onChange={(e) =>
                  handleChange(index, "taxPercentage", e.target.value)
                }
              />
            </div>   

            <div className="col-span-2">
              <input
                type="number"
                placeholder="CGST Percentage"
                className="w-full border rounded-md p-2 text-sm"
                value={task.cgstPercentage}
                onChange={(e) =>
                  handleChange(index, "cgstPercentage", e.target.value)
                }
              />
            </div>   

            <div className="col-span-2">
              <input
                type="number"
                placeholder="CGST Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.cgstAmount}
                onChange={(e) =>
                  handleChange(index, "cgstAmount", e.target.value)
                }
              />
            </div>   

            <div className="col-span-2">
              <input
                type="number"
                placeholder="SGST Percentage"
                className="w-full border rounded-md p-2 text-sm"
                value={task.sgstPercentage}
                onChange={(e) =>
                  handleChange(index, "sgstPercentage", e.target.value)
                }
              />
            </div>   

            <div className="col-span-2">
              <input
                type="number"
                placeholder="SGST Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.sgstAmount}
                onChange={(e) =>
                  handleChange(index, "sgstAmount", e.target.value)
                }
              />
            </div>   

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Tax Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.taxAmount}
                onChange={(e) =>
                  handleChange(index, "taxAmount", e.target.value)
                }
              />
            </div>   

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Discount Percentage"
                className="w-full border rounded-md p-2 text-sm"
                value={task.discountPercentage}
                onChange={(e) =>
                  handleChange(index, "discountPercentage", e.target.value)
                }
              />
            </div>   

            <div className="col-span-2">
              <input
                type="number"
                placeholder="Discount Amount"
                className="w-full border rounded-md p-2 text-sm"
                value={task.discountAmount}
                onChange={(e) =>
                  handleChange(index, "discountAmount", e.target.value)
                }
              />
            </div>   

            <div className="col-span-2">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-1 text-center hover:border-blue-500 transition">
                <input
                  type="file"
                  multiple
                  // accept="image/*"
                  className="hidden"
                  id={`file-${index}`}
                  onChange={(e) => handleFileChange(index, e.target.files)}
                />

                <label
                  htmlFor={`file-${index}`}
                  className="cursor-pointer text-sm text-blue-600"
                >
                  Click to upload Attachments
                </label>

                {/* <p className="text-xs text-gray-400 mt-1">PNG, JPG up to 5MB</p> */}
              </div>
              <div className="flex gap-2 mt-2 flex-wrap">
                {task.attachements?.map((file, i) => (
                  <div key={i} className="relative">
                    <img
                      src={file.url || file?.path || file?.Location || file}
                      alt="preview"
                      onClick={() => {
                        handleImageOpen(
                          file.url || file?.path || file?.Location || file,
                        );
                      }}
                      className="w-4 h-4 object-cover rounded-md border"
                    />

                    {/* <button
                      type="button"
                      onClick={() => removeImage(index, i)}
                      className="absolute -top-2 -right-2 bg-white border rounded-full text-red-500 px-1 text-xs"
                    >
                      ✕
                    </button> */}
                  </div>
                ))}
              </div>
            </div>

            {/* <div className="col-span-12">
              <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <h3 className="text-sm font-semibold text-gray-800">
                      Tax Details
                    </h3>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      CGST (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.cgstPercentage}
                        onChange={(e) =>
                          handleChange(index, "cgstPercentage", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      SGST (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.sgstPercentage}
                        onChange={(e) =>
                          handleChange(index, "sgstPercentage", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Total Tax (%)
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        placeholder="0"
                        value={task.totalTaxPercentage ?? ""}
                        onChange={(e) =>
                          handleChange(
                            index,
                            "totalTaxPercentage",
                            e.target.value,
                          )
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-3 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm">
                        %
                      </span>
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Tax Amount (₹)
                    </label>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                        ₹
                      </span>
                      <input
                        type="number"
                        value={task.totalTaxAmount ?? ""}
                        onChange={(e) =>
                          handleChange(index, "totalTaxAmount", e.target.value)
                        }
                        className="w-full h-11 border border-gray-300 rounded-lg pl-8 pr-3 text-sm bg-green-50 font-medium"
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-4 flex justify-end">
                  <div className="bg-gray-50 border rounded-lg px-4 py-2">
                    <span className="text-xs text-gray-500">GST Rate</span>
                    <div className="text-lg font-semibold text-blue-600">
                      {task.totalTaxPercentage || 0}%
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-span-1 text-center">
              <div className="flex gap-4">
                <button
                  type="button"
                  title="Delete"
                  onClick={() => removeRow(index)}
                  className="text-red-500 hover:text-red-700"
                >
                  <Trash2 size={24} />
                </button>
                <button
                  type="button"
                  title="Save"
                  onClick={() => saveRow(index)}
                  className="text-green-500 hover:text-green-700"
                >
                  <SaveAll size={24} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="col-span-12 md:col-span-12 bg-white shadow-lg rounded-2xl p-6 h-full mt-4">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">
          Service Billing Estimations
        </h2>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700, borderRadius: 10 }}>
            <TableHead>
                  <TableRow>
                    <TableCell>Labor Count</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Attachments</TableCell>
                    <TableCell>CGST Percentage</TableCell>
                    <TableCell align="right">SGST Percentage</TableCell>
                    <TableCell align="right">Total Tax Percentage</TableCell>
                    <TableCell align="right">Total Tax Amount</TableCell>
                    <TableCell align="right">Total Amount</TableCell>
                    <TableCell align="right">Edit</TableCell>
                    <TableCell align="right">Delete</TableCell>
                  </TableRow>
                </TableHead>

            <TableBody>
              {serviceBillDetails?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.taskDescription || "-"}</TableCell>
                  <TableCell>{row.panelDetails || "-"}</TableCell>
                  <TableCell>
                    {parseImages(row?.attachments)?.length > 0 ? (
                      <div className="grid grid-cols-4 gap-2">
                        {parseImages(row?.attachments).map((file, index) => {
                          const url =
                            file?.path || file?.url || file?.Location || file;

                          const type = getFileType(url);

                          return (
                            <div
                              key={index}
                              className="w-10 h-10 flex items-center justify-center border rounded-lg overflow-hidden cursor-pointer bg-gray-50"
                              onClick={() => handleImageOpen(url)}
                            >
                              {type === "image" && (
                                <img
                                  src={url}
                                  alt="attachment"
                                  className="w-full h-full object-cover"
                                />
                              )}

                              {type === "video" && (
                                <video className="w-full h-full object-cover">
                                  <source src={url} />
                                </video>
                              )}

                              {type === "pdf" && (
                                <span className="text-xs text-red-500 font-semibold">
                                  PDF
                                </span>
                              )}

                              {type === "doc" && (
                                <span className="text-xs text-blue-500 font-semibold">
                                  DOC
                                </span>
                              )}

                              {type === "other" && (
                                <span className="text-xs text-gray-500">
                                  FILE
                                </span>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.laborCost)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.cgstPercentage)}
                  </TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.sgstPercentage)}
                  </TableCell>
                  <TableCell align="right">{ccyFormat(row.totalTax)}</TableCell>
                  <TableCell align="right">
                    {ccyFormat(row.totalCost)}
                  </TableCell>
                  {/* <TableCell align="right">
                            <button
                              type="button"
                              title="Save"
                              onClick={() => {
                                setCreationType({ type: "edit", id: row.id });
                                setActiveTab("vehicleservicetasks");
                                setServiceBillData([
                                  {
                                    description: row.taskDescription || "",
                                    panelDetails: row.panelDetails || "",
                                    attachements: JSON.parse(row.attachments) || [],
                                    cost: row.totalCost || "",
                                    laborCost: row.laborCost || "",
                                  },
                                ]);
                              }}
                              className="text-green-500 hover:text-green-700"
                            >
                              <Pencil size={24} />
                            </button>
                          </TableCell> */}
                </TableRow>
              ))}

              {/* <TableRow>
                        <TableCell
                          colSpan={4}
                          align="right"
                          sx={{ fontWeight: "bold" }}
                        >
                          Grand Total
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                          {ccyFormat(grandTotalForTasks)}
                        </TableCell>
                      </TableRow> */}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default Servicelogbillestimation;
